import { render, staticRenderFns } from "./Idi.html?vue&type=template&id=6978c5cd&scoped=true&external"
import script from "./Idi.vue?vue&type=script&lang=js"
export * from "./Idi.vue?vue&type=script&lang=js"
import style0 from "./Idi.scss?vue&type=style&index=0&id=6978c5cd&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6978c5cd",
  null
  
)

export default component.exports